import { useRef, type MouseEvent, type ReactNode } from "react";

interface Props {
  onClose: () => void;
  className: string;
  children?: ReactNode;
}

export default function BackdropCloseContainer({
  onClose,
  className,
  children,
}: Props) {
  const pressedOnBackdropRef = useRef(false);

  function handleMouseDown(e: MouseEvent<HTMLDivElement>) {
    pressedOnBackdropRef.current = e.target === e.currentTarget;
  }

  function handleMouseUp(e: MouseEvent<HTMLDivElement>) {
    const shouldClose = pressedOnBackdropRef.current && e.target === e.currentTarget;
    pressedOnBackdropRef.current = false;
    if (shouldClose) onClose();
  }

  return (
    <div
      className={className}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      {children}
    </div>
  );
}
